import { useEffect, useState } from 'react';
import { useAuth, useUserData } from '../../../lib/auth';
import { usePermissions } from '../../../lib/hooks/usePermissions';
import { useCalendarSharingStore } from '../../../lib/stores/calendarSharingStore';
import { ShareMyCalendarPanel } from '../../calendar/ShareMyCalendarDialog';
import { LinkedCalendarsTab } from './LinkedCalendarsTab';
import { AppearanceTab } from './AppearanceTab';
import { WorkHoursTab } from './WorkHoursTab';

const TABS = [
  { id: 'linked', label: 'Calendari collegati' },
  { id: 'share', label: 'Condivisione' },
  { id: 'look', label: 'Aspetto' },
  { id: 'hours', label: 'Orario di lavoro' },
] as const;
type TabId = typeof TABS[number]['id'];

/** Profilo › Il mio calendario: collegamenti Google e Outlook, condivisione, aspetto, orario. */
export function MyCalendarSection() {
  const { user } = useAuth();
  const { organizationId } = useUserData();
  const { hasPermission } = usePermissions();
  const { ready, load } = useCalendarSharingStore();
  const [tab, setTab] = useState<TabId>('linked');

  useEffect(() => {
    if (ready || !user?.id || !organizationId) return;
    void load({
      meId: user.id,
      organizationId,
      canSeeAll: hasPermission('calendar_others', 'view'),
      canEditOthers: hasPermission('calendar_others', 'update'),
    });
  }, [ready, user?.id, organizationId, load, hasPermission]);

  return (
    <div>
      <div role="tablist" className="flex gap-1 overflow-x-auto border-b border-[rgba(55,53,47,0.09)] dark:border-white/10">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={`whitespace-nowrap px-3 py-2 text-[13px] font-medium border-b-2 -mb-px transition-colors ${tab === t.id ? 'border-[#37352F] text-[#37352F] dark:border-white dark:text-white' : 'border-transparent text-[#787774] hover:text-[#37352F] dark:hover:text-white'}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="pt-4">
        {!ready ? (
          <p className="text-[13px] text-[#787774]">Carico le impostazioni del calendario...</p>
        ) : (
          <>
            {tab === 'linked' && <LinkedCalendarsTab userId={user?.id} organizationId={organizationId || undefined} />}
            {tab === 'share' && <ShareMyCalendarPanel />}
            {tab === 'look' && <AppearanceTab />}
            {tab === 'hours' && <WorkHoursTab />}
          </>
        )}
      </div>
    </div>
  );
}

export default MyCalendarSection;
